module.exports = require("core-js/library/fn/string/from-code-point");